export default __webpack_public_path__ + "static/media/struct3.8bccdc40.png";